import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import ConsultancyFirmsList from '../components/ConsultancyFirmsList'

export default function ConsultancyFirms() {

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  return (
    <div className='eczmembers'>
      <div className="memberTitleContainer">
        <h1 className="newMemberTitle">Consultancy Firms</h1>
        <Link to="/new-consultancy-firm"><button className="memberAddButton">Create New</button></Link>
      </div>
        <ConsultancyFirmsList />
    </div>
  )
}
